import { createTheme } from "@mui/material/styles";

const theme = (local: any) =>
  createTheme(
    {
      cssVariables: {
        colorSchemeSelector: "data-toolpad-color-scheme",
      },
      colorSchemes: { light: true, dark: true },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 600,
          lg: 1200,
          xl: 1536,
        },
      },
      palette: {
        mode: "light",
        background: {
          default: "#F7F7F7", // Digital BG Grey
          paper: "#FFFFFF", // White
        },
        primary: {
          main: "#596774", // Digital Cool Grey
          contrastText: "#FFFFFF",
        },
        secondary: {
          main: "#60676D", // Dark Grey
        },
        error: {
          main: "#C63A50", // Functional Red
        },
        warning: {
          main: "#F9BF14", // Functional Yellow
        },
        info: {
          main: "#32ABD4", // Functional Blue
        },
        success: {
          main: "#65B783", // Functional Green
        },
        text: {
          primary: "#25282A", // Digital Black
          secondary: "#596774", // Digital Cool Grey
        },
        grey: {
          100: "#CCD2D7", // Light Grey
          200: "#D7E0EB", // Clear Grey
          300: "#9CB7D4", // Ice Grey
        },
      },
      shape: {
        borderRadius: 12, // Rounded components per "circularity" keyword
      },
      typography: {
        fontFamily: `'Montserrat', 'Helvetica', 'Arial', sans-serif`,
      },
      components: {
        MuiContainer: {
          styleOverrides: {
            root: {
              [`@media (min-width:600px)`]: {
                paddingLeft: 0,
                paddingRight: 0,
              },
              [`@media (min-width:1200px)`]: {
                maxWidth: "none",
              },
            },
          },
        },
      },
    },
    local
  );

export default theme;
